export const GET_ADMISSION_FEE_VOUCHER_DATES = 'GET_ADMISSION_FEE_VOUCHER_DATES'
export const ADD_ADMISSION_FEE_VOUCHER_DATES = 'ADD_ADMISSION_FEE_VOUCHER_DATES'
export const UPDATE_ADMISSION_FEE_VOUCHER_DATES = 'UPDATE_ADMISSION_FEE_VOUCHER_DATES'
export const DELETE_ADMISSION_FEE_VOUCHER_DATES = 'DELETE_ADMISSION_FEE_VOUCHER_DATES'
export const DELETE_MANY_ADMISSION_FEE_VOUCHER_DATES = 'DELETE_MANY_ADMISSION_FEE_VOUCHER_DATES'
